__turbopack_context__.v({
  "bioCoatingCardWrapper": "STOurTechnology-module__PM0w5W__bioCoatingCardWrapper",
  "bioCoatingIcon": "STOurTechnology-module__PM0w5W__bioCoatingIcon",
  "bioCoatingItem": "STOurTechnology-module__PM0w5W__bioCoatingItem",
  "emissionsImpactContent": "STOurTechnology-module__PM0w5W__emissionsImpactContent",
  "emissionsImpactImageWrapper": "STOurTechnology-module__PM0w5W__emissionsImpactImageWrapper",
  "emissionsImpactvalue": "STOurTechnology-module__PM0w5W__emissionsImpactvalue",
  "imageItem": "STOurTechnology-module__PM0w5W__imageItem",
  "insightsCard": "STOurTechnology-module__PM0w5W__insightsCard",
  "insightsCardWrapper": "STOurTechnology-module__PM0w5W__insightsCardWrapper",
  "insightsImageWrap": "STOurTechnology-module__PM0w5W__insightsImageWrap",
  "safGuideContent": "STOurTechnology-module__PM0w5W__safGuideContent",
  "safGuideImageWrapper": "STOurTechnology-module__PM0w5W__safGuideImageWrapper",
  "sustainableFuleContent": "STOurTechnology-module__PM0w5W__sustainableFuleContent",
  "sustainableFuleImageWrapper": "STOurTechnology-module__PM0w5W__sustainableFuleImageWrapper",
});
